import { call, put, takeLatest } from '@redux-saga/core/effects';
import type { SagaIterator } from '@redux-saga/core';
import { PayloadAction } from '@reduxjs/toolkit';
import { fetchIndex, updateLanguageAPI } from '../services/api';
import {
  fetchBhajanDataRequest,
  fetchBhajanDataSuccess,
  fetchBhajanDataFailure,
  refreshBhajanDataRequest,
  refreshBhajanDataSuccess,
} from '../Features/BhajanSlice';

function* fetchBhajanDataSaga(): SagaIterator {
  try {
    const catalog = yield call(fetchIndex);
    yield put(fetchBhajanDataSuccess(catalog));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'An unknown error occurred';
    yield put(fetchBhajanDataFailure(message));
  }
}

function* refreshBhajanDataSaga(action: PayloadAction<string>): SagaIterator {
  try {
    const language = action.payload;
    updateLanguageAPI(language);
    const catalog = yield call(fetchIndex, true);
    yield put(refreshBhajanDataSuccess(catalog));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'An unknown error occurred';
    yield put(fetchBhajanDataFailure(message));
  }
}

export default function* bhajanSagas() {
  yield takeLatest(fetchBhajanDataRequest.type, fetchBhajanDataSaga);
  yield takeLatest(refreshBhajanDataRequest.type, refreshBhajanDataSaga);
}
